export default "__VITE_ASSET__BCMxYu5Q__"